import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';

const baseURL = `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_API_VERSION}`;
export const unAuthedAxiosService = axios.create({ baseURL, withCredentials: true });
const axiosServices = axios.create({ baseURL, withCredentials: true });
const refreshService = axios.create({ baseURL, withCredentials: true });
let lock = false;
let subscribers: ((token: string) => void)[] = [];

// refresh Token 주입
refreshService.interceptors.request.use(
  (config) => {
    const refreshToken = localStorage.getItem('serviceToken');
    config.data = { refreshToken: `Bearer ${refreshToken}` };
    return config;
  },
  (error) => Promise.reject(error),
);

// refresh Token 조회시 에러 처리
refreshService.interceptors.response.use(
  (response) => response,
  (error) => {
    console.log(error);
    if (error.response?.status === 401 && error.response?.data.message === 'EMPTY_REFRESH_TOKEN'
        && !window.location.pathname.includes('login')) {
      window.location.href = '/login';
    }
    return Promise.reject((error.response?.data) || 'Wrong Services');
  },
);

const subscribeTokenRefresh = (cb: (token: string) => void) => {
  subscribers.push(cb);
};

const onRrefreshed = (token: string) => {
  subscribers.forEach((cb) => cb(token));
};

const getRefreshToken = async (): Promise<string | void> => {
  try {
    const response = await refreshService.post('member/auth/refresh');
    const { accessToken } = response.data.data;
    lock = false;
    onRrefreshed(accessToken);
    subscribers = [];
    localStorage.setItem('serviceToken', accessToken);
    return accessToken;
  } catch (e) {
    console.error(e);
    lock = false;
    subscribers = [];
    // localStorage.removeItem('serviceToken');
  }
};

axiosServices.interceptors.request.use(
  async (config) => {
    const accessToken = localStorage.getItem('serviceToken');
    if (accessToken) {
      config.headers.Authorization = `Bearer ${accessToken}`;
    }
    return config;
  },
  (error) => Promise.reject(error),
);

axiosServices.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    if (error.response.status === 401) {
      if (lock) {
        return new Promise((resolve) => {
          subscribeTokenRefresh((token: string) => {
            originalRequest.headers.Authorization = `Bearer ${token}`;
            resolve(axiosServices(originalRequest));
          });
        });
      }
      lock = true;
      const accessToken = await getRefreshToken();
      if (typeof accessToken === 'string') {
        error.config.headers.Authorization = `Bearer ${accessToken}`;
        return axios(error.config);
      }
    }
    return Promise.reject((error.response?.data) || 'Wrong Services');
  },
);

export default axiosServices;

const request = async (method: string, url:string, config?: AxiosRequestConfig | object) => {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-expect-error
  const res:AxiosResponse = await axiosServices[method](url, method === 'get' ? { ...config } : config);
  return res.data;
};

export const fetcher = async (url:string, config?: AxiosRequestConfig | object) => request('get', url, config);

export const fetcherPost = async (url:string, config?: AxiosRequestConfig | object) => request('post', url, config);

export const fetcherPut = async (url:string, config?: AxiosRequestConfig | object) => request('put', url, config);

export const fetcherPatch = async (url:string, config?: AxiosRequestConfig | object) => request('patch', url, config);

export const fetcherDelete = async (url:string, config?: AxiosRequestConfig | object) => request('delete', url, config);
